//CHID - 1   UshaRani.m   21 / 01 / 2020   standByMD-1969: Add Age Risk Factor when moving from Demographics to Location
import i18n from "./../../../i18n";
import initState from "../initState";
import moment from "moment";
import { defaultOrganizationId, platformIdentifier } from "client.config";
import differenceInCalendarYears from "date-fns/difference_in_calendar_years";
import { Trans } from "react-i18next";
import { checkAndGetLocalStorageValue, getFormattedDate, getDefaultDate, checkAndGetSessionStorageValue, generateJsonWebToken } from "../../../features/utils";
import { genderConst, commonConstant, applicationVersions } from "../../../server/triage/constants";

const status = {
  Approved: "Approved",
  Denied: "Denied",
};
let symptomType = "";

export function clearTriageSession({ actions, setState, getState }) {
  actions.clearSymptomState();
  actions.clearQuestionsState();
  setState(initState());
}

export function clearTriageSessionResults({ actions }) {
  actions.setTriageResponse({
    sessionResults: {},
    emergencySessionResults: {},
  });
}

export function resetQTState(state, setState) {
  if (state.UserNavigatedToQT) {
    setState({
      UserNavigatedToQT: false,
      QuickTeleMedAvailableOrNot: false,
      quickTelemedicine: false,
      triageResponse: {
        ...state.triageResponse,
        recommendedCareOptions: [],
      },
    });
  }
}
/**
 * Required fields to create session with GEMTriage API
 *
 * See: server/triage/actions/createSession
 */
const sessionProps = [
  "sessionId",
  "birthdate",
  "pregnant",
  "emergency",
  "ageInYears",
  "encounterToken",
];

const getSessionProps = (req) =>
  sessionProps.reduce((obj, key) => {
    if (key === "sessionId") {
      obj.identifier = req[key] + ""; // Ensure string
    } else {
      obj[key] = req[key];
    }
    return obj;
  }, {});

export async function createTriageSession({
  props = {},
  state,
  actions,
  nextStepName,
  history,
  setState,
  isEmergency
}) {
  const { hasCurrentLocation, emergency = false, isFacility = false, isTravelAid2 = false, isFacilitySearch = false } = props;
  window.store = store;
  const { triageRequest } = state;
  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")

  let { ageInYears } = triageRequest;
  if (!emergency && !state.isFacility && !state.isTravelAid2 && !state.isFacilitySearch) {
    const symptoms = await actions.sendTriageRequest({
      action: "refreshSymptomDatabase",
      data: {
        searchText: "",
        Language: actions.getLanguage(i18n.language),
        age: ageInYears,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
      },
    });
    if (symptoms && symptoms.message === commonConstant.success) {
      localStorage.setItem("symptoms", JSON.stringify(symptoms));
    }
  }

  const encounterToken = localStorage.getItem("token");
  actions.setTriageRequest({ emergency });

  const reqData = getSessionProps({
    ...state.triageRequest,
    emergency,
    encounterToken,
  });
  reqData.User = checkAndGetLocalStorageValue("userEmail");
  localStorage.setItem("isPatientDetailsAdded", false);
  let { gender, policyNumber } = triageRequest;
  let langId;
  langId = actions.getLanguage(i18n.language);

  let genderFemale = "female";
  let genderMale = "male";
  if (gender === "F") gender = genderFemale;
  if (gender === "M") gender = genderMale;
  if (emergency) {
    var dob = checkAndGetLocalStorageValue("dateOfBirth");
    reqData.gender = checkAndGetLocalStorageValue("gender");
    if (dob != "") {
      var dateOfBirth = new Date(dob);
      var age = differenceInCalendarYears(new Date(), dateOfBirth);
      reqData.ageInYears = age;
      reqData.DOB = getFormattedDate(dateOfBirth, 0, 1, 0);
    }
    else {
      reqData.ageInYears = 0;
      reqData.DOB = getDefaultDate();
    }
    actions.setTriageRequest({ dateofbirth: reqData.DOB });

  }
  policyNumber = (policyNumber == "" || policyNumber == undefined) ? localStorage.getItem("policyNumber") : policyNumber
  const data = {
    LanguageId: langId,
    gender,
    policyNumber,
    jwtAccessToken: jwtAccess_Token,
    accessToken: access_Token,
    organizationId: checkAndGetLocalStorageValue("orgid"),
    platformId: platformIdentifier,
    isEmergency: isEmergency,
    ApplicationVersionId: state.isFacility ? applicationVersions.FindFacility :
      (state.isTravelAid2 ? applicationVersions.TravelAid2 : applicationVersions.TravelAid1),
    ...reqData,
  };
  //await actions.refreshSymptoms({data})
  //create session for find-facility and travelAid2
if (state.triageRequest.sessionId > 0)
{
    const sessionResponse = await actions.sendTriageRequest({
      action: emergency || isFacility || isFacilitySearch ? "createEmergencySession" : "createSession",
      data,
    });
    var languageCode = checkAndGetSessionStorageValue("languageCode");
    setState({
        defaultLanguageCode: languageCode
    })
    var result = false;
    if (sessionResponse && sessionResponse.message === commonConstant.success) {
      result = true;
    }

    //updating Organization 
    const { sessionId } = state.triageRequest;
    const organizationData = {
      "organization": localStorage.getItem("organization"),
      "token": localStorage.getItem("token"),
      "identifier": sessionId,
      "policyNumber": policyNumber,
      "organizationId": checkAndGetLocalStorageValue("orgid"),
      "subOrganization": "Self Service",
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
    };

    // console.log("Organization Data -- ", organizationData);

    await actions.sendTriageRequest({
      action: "updateOrganization",
      data: organizationData,
    });
    //CHID-1 1969 start
    if (result && localStorage.getItem("IsEmergencySelected") == "false" && !state.isFacility && !state.isTravelAid2 && !state.isFacilitySearch) {
      if (gender == genderConst.Female) {
        actions.AddAgeRiskFactor();
      }
      actions.UpdateRiskFactors();
      setState({
        isLoading: false,
      });
      state.triageRequest.activeMenu = "location";
      history.push(`/find-care-options/${"location"}`);
    }
    //CHID-1 1969 end
    if (result && localStorage.getItem("IsEmergencySelected") == "true") {
      setState({
        isLoading: false,
      });
      state.triageRequest.activeMenu = "location";
      history.push(`/find-care-options/${"location"}`);
    }
    if (result && hasCurrentLocation) {
      setState({
        isLoading: false,
      });
      await actions.submitTriageLocation();
    }
  }
}

export async function createTriageEmergencySession({
  props,
  state,
  actions,
  nextStepName,
  history,
}) {
  await actions.createTriageSession({
    ...props,
    emergency: true,
    nextStepName,
    history,
  });
}

export async function submitTriageSession({ state, actions }) {
  const { sessionId } = state.triageRequest;
  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  var lantest = i18n.language;
  var lang = actions.getLanguage(lantest);
  var action = state.isTravelAid2 && !state.triageRequest.emergency && !state.triageRequest.isFacilitySearch ? "submitNewTriageSession" : "submitSession";
  await actions.sendTriageRequest({
    action: action,
    data: {
      identifier: sessionId,
      token: localStorage.getItem("token"),
      LanguageId: lang,
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
    },
  });
}

export function generalDate({ dateVal }) {
  var convertedDate =
    moment(new Date(dateVal.toString().substr(0, 24))).format(
      "YYYY-MM-DDTHH:mm:ss"
    ) + ".001Z";
  return convertedDate;
}

export async function validateOrganizationApi(
  state,
  setState,
  actions,
  orgId,
  IsRegularLogin
) {
  var responseStatus = false;
  var isOrgValid;

  if (IsRegularLogin) {
    isOrgValid = await validateOrganizationExistence(state, setState, actions, orgId, IsRegularLogin);
  } else {
    await getContextIdForNonLoginOrg(state, setState, actions, orgId, IsRegularLogin);
    isOrgValid = await getOrgDetailForNonLogin(state, setState, actions, orgId);
  }

  if (isOrgValid) {
    var isValidOrgSubscription = await validateOrganizationSubscription(
      state,
      setState,
      actions,
      orgId,
      IsRegularLogin
    );
    if (isValidOrgSubscription) {
      responseStatus = true;
    }
  }
  return responseStatus;
}

export async function getOrgImageApi({
  state,
  setState,
  actions,
  shouldLoaderbeLoaded,
  isNewFlow = false,
  facilityFLow = true
}) {
  var orgName = checkAndGetLocalStorageValue("organization");
  var organizationId = checkAndGetLocalStorageValue("orgid");

  async function customizationCall(url) {
    var customizationQuery = url;
    const command = "get/customization/customizations";
    const body = { url: customizationQuery };
    const filedatainfo = await actions.postNodeCallBack(
      state,
      setState,
      actions,
      command,
      body
    );
    var customizeResponse = filedatainfo.response.results;

    if (
      filedatainfo &&
      filedatainfo.success === commonConstant.true &&
      customizeResponse != null &&
      customizeResponse.length >= 1
    ) {
      return customizeResponse;
    }
    return null;
  }
  if (isNewFlow) {
    var body =
      "?ownerEntityUri=/organizations/" +
      organizationId +
      "&type=Feature" +
      "&scope=" +
      process.env.AZURE_MOSAIQUE_SCOPE +
      "&name=Features.All";

    var customizeResponse = await customizationCall(body);
    if (customizeResponse) {

      customizeResponse.map((item) => {
        var actionList = item.rule.actions;

        actionList.map((data) => {
          var outComeName = data.outcomeItem;

          if (outComeName.name === "QuickTelemedicineEnabled") {
            if (outComeName.values[0] === "true") {
              setState({
                QuickTeleMedAvailableOrNot: true,
              });

            } else {
              setState({
                QuickTeleMedAvailableOrNot: false,
              });

            }
          }
        });
      });
    } else {
      setState({
        QuickTeleMedAvailableOrNot: false,
      });
    }
    if (state.UserNavigatedToQT) {
      setState({
        UserNavigatedToQT: false,
        quickTelemedicine: false,
        triageResponse: {
          ...state.triageResponse,
          recommendedCareOptions: [],
        },
      });
    }
  } else {
    if (orgName !== commonConstant.GEMName) {
      var body =
        "?ownerEntityUri=/organizations/" +
        organizationId +
        "&type=Branding" +
        "&scope=" +
        process.env.AZURE_MOSAIQUE_SCOPE;
      var customizeResponse = await customizationCall(body);

      var rulesOfActions = customizeResponse[0].rule.actions;
      let filename = rulesOfActions[0].outcomeItem.values[0];
      setState({
        isLoading: shouldLoaderbeLoaded,
        screenLoaded: true,
        base64: filename,
      });
    }
  }
}

export async function organizationCall({ state, actions, setState, shouldLoaderbeLoaded }) {
  var orgid = localStorage.getItem("orgid");
  let lng = i18n.language;
  var browserLang = lng.split("-")[0];
  if (browserLang === null) {
    browserLang = "en";
  }
  var privacyLocal = checkAndGetLocalStorageValue("privacy");
  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")
  if (privacyLocal.length <= 0 && !state.isFacility && !state.isTravelAid2) {
    const privacyinfo = await actions.sendTriageRequest({
      action: "privacypolicy",
      data: {
        orgnid: orgid,
        Language: browserLang,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
      },
    });
    if (privacyinfo && privacyinfo.message === commonConstant.success) {
      const privacyData = privacyinfo;
      const privacyLink = privacyData.privacyData;

      if (privacyLink && privacyLink.length >= 1) {
        localStorage.setItem("privacy", privacyLink);
      }
    }
  }
  setState({
    privacy: localStorage.getItem("privacy")
  })
  var termsLocal = checkAndGetLocalStorageValue("terms");
  if (termsLocal.length <= 0 && !state.isFacility && !state.isTravelAid2) {
    const termsinfo = await actions.sendTriageRequest({
      action: "term",
      data: {
        orgnid: orgid,
        Language: browserLang,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
      },
    });
    if (termsinfo && termsinfo.message === commonConstant.success) {
      const termsData = termsinfo;
      const termsLink = termsData.termsData;

      if (termsLink.length >= 1) {

        localStorage.setItem("terms", termsLink);
      }
    }
  }
  setState({
    terms: localStorage.getItem("terms"),
  })

  let languageCode = checkAndGetSessionStorageValue("languageCode");

  if (languageCode === undefined || languageCode === null && orgid === defaultOrganizationId) {
    i18n.changeLanguage("en");
  } else {
    const dataforlng = await actions.sendTriageRequest({
      action: "getdefaultlng",
      data: {
        orgnid: orgid,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
      },
    });
    if (dataforlng && dataforlng.message === commonConstant.success) {
      const { defaultLang } = dataforlng;
      console.log("defaultlanguage", defaultLang.language);

      let appLanguage = languageCode ? languageCode : defaultLang.language;
      setState({
        defaultLanguageCode: appLanguage
      })
      i18n.changeLanguage(appLanguage);
    }
  }
  getOrgImageApi({ state, setState, actions, shouldLoaderbeLoaded });
}
export async function validateOrganizationExistence(state, setState, actions, orgId, IsRegularLogin) {
  var responseStatus = false;
  var shouldLoaderbeLoaded = true;
  if (!IsRegularLogin) {
    await organizationCall({ state, actions, setState, shouldLoaderbeLoaded });
  }
  const command = "get/organizationbyuniqueidentifier?organizationId=" + orgId;
  const orgData = await actions.getNodeCallBack(state, setState, actions, command);

  if (orgData && orgData.success === commonConstant.true) {
    if (orgData === undefined) {
      return (responseStatus);
    }

    if (orgData !== undefined && orgData.success === commonConstant.true) {
      localStorage.setItem("organization", orgData.response.legalName);
      responseStatus = true;
      return (responseStatus);
    } else {
      return (responseStatus);
    }
  }
}

export async function getOrgDetailForNonLogin(state, setState, actions, orgId) {
  var responseStatus = false;
  const data =
    "?organizationId=" + orgId +
    "&branchId=" + checkAndGetLocalStorageValue("contextId");
  const command = "get/organization" + data;
  const orgData = await actions.getNodeCallBack(state, setState, actions, command);

  if (orgData && orgData.success === commonConstant.true) {
    if (orgData === undefined) {
      return (responseStatus);
    }
    if (orgData !== undefined && orgData.success === commonConstant.true) {
      if (orgData.response.results[0]) {
        localStorage.setItem("organization", orgData.response.results[0].legalName);
      }
      responseStatus = true;
      return (responseStatus);
    } else {
      return (responseStatus);
    }
  }
}

export async function getContextIdForNonLoginOrg(
  state,
  setState,
  actions,
  orgId,
  IsRegularLogin
) {
  var responseStatus = false;
  var shouldLoaderbeLoaded = true;
  if (!IsRegularLogin) {
    await organizationCall({ state, actions, setState, shouldLoaderbeLoaded });
  }
  const command = "privacy/contract";
  var customizationQuery =
    "intendedActionName=read&targetName=Organization&applyContextFilter=true&contextPathEntityUri=/organizations/" + orgId;
  const body = { url: customizationQuery };
  const orgData = await actions.postNodeCallBack(
    state,
    setState,
    actions,
    command,
    body
  );
  if (orgData && orgData.success === commonConstant.true) {
    if (orgData === undefined) {
      return responseStatus;
    }

    if (orgData !== undefined && orgData.success === commonConstant.true) {
      localStorage.setItem("contextId", orgData.response.results[0].parties[0].contextId);
      responseStatus = true;
      return responseStatus;
    } else {
      return responseStatus;
    }
  }
}

export async function validateOrganizationSubscription(
  state,
  setState,
  actions,
  orgId,
  IsRegularLogin
) {
  var responseStatus = false;
  const subscriptionUrl =
    "?billableItemUri=/billable-items/9c8fcef6-849c-4788-8877-29929fa984bd&subscriberEntityUri=/organizations/" +
    orgId;

  const command = "get/subcription/details";
  const body = { url: subscriptionUrl };
  const subscriptionObject = await actions.postNodeCallBack(state, setState, actions, command, body);

  if (subscriptionObject && subscriptionObject.success === commonConstant.true) {
    var orgDetails = subscriptionObject;
    if (
      subscriptionObject != undefined &&
      orgDetails.response.results.length > 0 &&
      orgDetails.response.results[0].status === status.Approved
    ) {
      if (IsRegularLogin) {
        setState({
          IsOrgSubscriptionValid: true,
          IsValidUser: false,
        });
      } else {
        if (window.location.pathname == "/find-facility") {
          setState({
            isDisplayLogin: true,
            IsValidUser: false,
            isFacility: true, // for facility search flow to work
            IsOrgSubscriptionValid: true,
            IsUserSubscriptionValid: true,
            isTravelAid2: false,
            isTriageGoingForRegularUser: true,
          });
          sessionStorage.setItem("isFacility", true);
        }
        else if (window.location.pathname == "/triageNew") {
          setState({
            isDisplayLogin: true,
            IsValidUser: true,
            isFacility: false,
            IsOrgSubscriptionValid: true,
            IsUserSubscriptionValid: true,
            isTravelAid2: true
          })
          sessionStorage.setItem("isTravelAid2", true)
        }
        else {
          setState({
            isTravelAid2: false,
            isDisplayLogin: true,
            IsValidUser: true,
            isFacility: false,
            IsOrgSubscriptionValid: true,
            IsUserSubscriptionValid: true,
            //5197 for Dr.Walter flow to work as there is no person subscription check
          });
          sessionStorage.setItem("isTravelAid2", false);
          sessionStorage.setItem("IsValidUser", true);
        }

        //5278 Set browser language as default language for non-login users.
        let languageCode = checkAndGetSessionStorageValue("languageCode");

        if (languageCode === "") {
          var currentBrowserLang =
            window.navigator.userLanguage || window.navigator.language;
          var splitLangArr = currentBrowserLang.split("-")[0];
          splitLangArr = splitLangArr ? splitLangArr : commonConstant.enLanguage;

          if (
            splitLangArr === "en" ||
            splitLangArr === "fr" ||
            splitLangArr === "es" ||
            splitLangArr === "de"
          ) {
            window.sessionStorage.setItem("languageCode", splitLangArr);
            i18n.changeLanguage(splitLangArr);
            setState({
              defaultLanguageCode: splitLangArr
            });
          } else {
            window.localStorage.setItem("i18nextLng", commonConstant.enLanguage);
            setState({
              defaultLanguageCode: commonConstant.enLanguage
            })
            i18n.changeLanguage(commonConstant.enLanguage);
          }
        }
      }
      const { triageRequest } = state;
      const hasCurrentLocation =
        triageRequest.location.lat && triageRequest.location.lng;
      var currentPath = window.location.pathname;
      if (currentPath === "/find-facility") {
        actions.createTriageSession({
          isFacility: true,
          hasCurrentLocation,
          history,
          setState,
        });
      }

      sessionStorage.setItem("IsOrgSubscriptionValid", true);
      responseStatus = true;
      var shouldLoaderbeLoaded = false;
      var isNewFlow = true;
      var facilityFLow = false;
      if (sessionStorage.getItem("isTravelAid2") !== "true") {
        await getOrgImageApi({ state, setState, actions, shouldLoaderbeLoaded, isNewFlow });
      }
      return (responseStatus);
    } else {
      if (IsRegularLogin) {
        setState({
          IsOrgSubscriptionValid: false,
          IsValidUser: false,
        });
      } else {

        if (window.location.pathname == "/find-facility") {
          setState({
            IsValidUser: false,
            isFacility: true, // for facility search flow to work
            IsOrgSubscriptionValid: false,
            isTravelAid2: false,
            isTriageGoingForRegularUser: true,
          });
          sessionStorage.setItem("isFacility", true);
        }
        else if (window.location.pathname == "/triageNew") {
          setState({
            IsValidUser: true,
            isFacility: false,
            IsOrgSubscriptionValid: false,
            isTravelAid2: true,
          })
          sessionStorage.setItem("isTravelAid2", true)
        }
        else {
          setState({
            IsValidUser: true,
            isFacility: false,
            IsOrgSubscriptionValid: false,
            isTravelAid2: false,
          });
          sessionStorage.setItem("IsValidUser", false);
        }
      }
      sessionStorage.setItem("IsOrgSubscriptionValid", false);
      return (responseStatus);
    }
  }
}

export async function callExternalIndentities(state, setState, actions) {
  var email = state.triageRequest.mailValidation.email;
  var domain = email.substr(email.lastIndexOf("@") + 1);
  var encodedEmail = encodeURIComponent((email.substr(0, email.lastIndexOf("@"))).trim());
  var emailId = { email: (encodedEmail + '@' + domain).toLowerCase() };

  const urlBuilderForIdentyProperties =
    "get/externalIdentities?ExternalIdentityScope=" +
    process.env.AZURE_ADB2C_BASE_SCOPE + "&ExternalIdentityType=Azure AD B2C" +
    "&identifyingPropertyKeyName=identities[0].issuerAssignedId&identifyingPropertyKeyValue=";

  const command = urlBuilderForIdentyProperties + emailId.email;

  const response = await actions.getNodeCallBack(state, setState, actions, command);

  if (response && response.success === commonConstant.true) {
    return (response);
  }
}

export async function validateOrganizationDetails(state, setState, actions, history, organizationId) {
  var IsRegularLogin = false;

  var responseStatus = await validateOrganizationApi(state, setState, actions, organizationId, IsRegularLogin);
  if (responseStatus) {
    var currentPath = window.location.pathname;
    if (currentPath === "/triageNew" || (currentPath === "/terms")) {
      history.push({
        pathname: "/triageNew",
        search: "?organizationId=" + localStorage.getItem("orgid"),
      })
    }
    else if (currentPath === "/find-facility") {
      history.push({
        pathname: "/find-facility",
        search: "?organizationId=" + localStorage.getItem("orgid"),
      });
    }
    else {
      history.push({
        pathname: "/terms",
        search: "?organizationId=" + localStorage.getItem("orgid"),
      });
    }
  } else {
    actions.setErrorModal({
      title: <Trans i18nKey="findcareoption.Careoptions.Alert"></Trans>,
      message: <Trans i18nKey="findcareoption.Careoptions.RestrictionMessage"></Trans>,
      comingFrom: commonConstant.orgSubscription,
      setState
    })
  }
  setTimeout(() => {
    setState({
      isLoading: false,
    });
  }, 1000);
}